module.exports = __webpack_public_path__ + "static/media/Picture70.e66bae68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture70.png
// module id = 1558
// module chunks = 0